const INDICES = [
  {
    title: '娱乐圈年度大瓜盘点',
    desc: '回顾今年娱乐圈最劲爆的吃瓜事件，从恋爱官宣到分手撕逼，一篇看完。',
    count: '36篇',
    icon: 'ri-movie-line',
    color: 'primary',
  },
  {
    title: '网红圈塌房合集',
    desc: '那些年塌房的网红们，人设崩塌背后的故事比电视剧还精彩。',
    count: '24篇',
    icon: 'ri-user-unfollow-line',
    color: 'accent',
  },
  {
    title: '综艺节目争议全纪录',
    desc: '从剪辑争议到选手黑幕，热门综艺背后的那些不可说。',
    count: '19篇',
    icon: 'ri-tv-line',
    color: 'primary',
  },
  {
    title: '企业家恩怨风云录',
    desc: '商界大佬们的爱恨情仇，比商战大片还要跌宕起伏。',
    count: '15篇',
    icon: 'ri-briefcase-line',
    color: 'accent',
  },
  {
    title: '体育圈花边新闻',
    desc: '赛场之外的体育明星们，私生活比比赛更引人注目。',
    count: '22篇',
    icon: 'ri-football-line',
    color: 'primary',
  },
  {
    title: '海外吃瓜精选',
    desc: '全球娱乐圈和社交媒体的热门话题，不出国门吃遍世界瓜。',
    count: '28篇',
    icon: 'ri-global-line',
    color: 'accent',
  },
  {
    title: '社会热点深度解读',
    desc: '从吃瓜角度解读社会热点事件，提供不一样的观察视角。',
    count: '31篇',
    icon: 'ri-newspaper-line',
    color: 'primary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            吃瓜网站首页精选专题，按主题整理51吃瓜网最热门内容，方便您一站式阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {INDICES.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group bg-background-100 rounded-xl p-5 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center mb-4 ${
                  item.color === 'primary' ? 'bg-primary-100' : 'bg-accent-100'
                }`}
              >
                <i
                  className={`${item.icon} text-lg ${
                    item.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                  }`}
                ></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{item.desc}</p>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#ranking"
            className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}